import _ from 'lodash';
import User from '../../models/User';

export const UserSorts = {

  /**
   * @param {Array<any>} users list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByEmail (users, reversed = false) {
    const result = _.sortBy(users, u => User.getEmail(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} users list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByAddedDate (users, reversed = false) {
    const result = _.sortBy(users, 'admin_add_date');
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} users list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByAuthorizedDate (users, reversed = false) {
    const result = _.sortBy(users, 'hero_authorized_date');
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} users list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByName (users, reversed = false) {
    const result = _.sortBy(users, u => User.getDisplayName(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  },

  /**
   * @param {Array<any>} users list
   * @param {boolean} reversed Pass true to reverse the sort
   * @return {Array<any>} sorted list
   */
  copySortedByRole (users, reversed = false) {
    const result = _.sortBy(users, u => User.getRoleType(u).toLowerCase());
    return reversed ? _.reverse(result) : result;
  }

};
